import { useQuery } from '@tanstack/react-query';
import type { EndConsumerSearch, EndConsumerSearchResponse } from '@metron/shared';
import { toEndConsumerSearchParams } from '@metron/shared';
import { useApiClient } from './useApiClient.ts';

/**
 * Runs a Smart Search end consumer spec against `GET /end-consumers/filter` (MET-3528).
 * Same caching and previous-page behavior as `useMeterFilter`.
 */
export function useEndConsumerFilter(spec: EndConsumerSearch | null) {
  const apiClient = useApiClient();
  const params = spec ? toEndConsumerSearchParams(spec).toString() : '';

  return useQuery({
    queryKey: ['end-consumer-filter', params],
    queryFn: () => apiClient.get<EndConsumerSearchResponse>(`end-consumers/filter?${params}`),
    enabled: spec !== null,
    placeholderData: (previous) => previous,
  });
}
